import React, { useEffect, useRef, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import fetchRoute from "utils/routes";
import ListRedirections from "assets/js/scenes/publicHash/scenes/listRedirections/ListRedirections";
import { getUrlQueryParam } from "utils/urlUtils";
import store from "assets/js/store";
import { Dialog, DialogHandler } from "cakemail-ui-components/lib/react";

const PublicHash = () => {
	const dialog = useRef(null);
	const [redirecting, setRedirecting] = useState(true);
	useEffect(() => {
		if (
			!store.getState().global.account &&
			getUrlQueryParam("brandPreview") === "true"
		) {
			window.location = "#" + fetchRoute("brand");
		} else {
			setRedirecting(false);
		}

		DialogHandler.register(dialog.current);
	}, []);

	return (
		<div>
			<Dialog ref={dialog} />
			{!redirecting && (
				<Switch>
					<Route
						path={fetchRoute("listRedirections")}
						render={() => <ListRedirections />}
					/>
					<Redirect to={fetchRoute("signIn")} />
				</Switch>
			)}
		</div>
	);
};

export default PublicHash;
